/** How far a chair's centre stands off the edge, as for a round table. */
const CHAIR_OFFSET = 0.7;
/**
 * The outline: the flat edge from top-left to top-right, then the curve back.
 * `insetFt` draws it that many feet inside its own edges (a pedestal).
 */
export function halfRoundOutline(widthFt, heightFt, insetFt = 0, segments = 24) {
    const inset = Math.max(0, Math.min(insetFt, widthFt / 2 - 0.05, heightFt / 2 - 0.05));
    const rx = Math.max(0, widthFt / 2 - inset);
    const ry = Math.max(0, heightFt - inset * 2);
    const cx = widthFt / 2;
    const top = inset;
    const points = [];
    for (let i = 0; i <= segments; i++) {
        // 0 → the right end of the flat edge, π → the left end, through the bottom.
        const angle = (Math.PI * i) / segments;
        points.push({ x: cx + rx * Math.cos(angle), y: top + ry * Math.sin(angle) });
    }
    return points;
}
/** SVG path data for the outline, scaled by `pxPerFt`. */
export function halfRoundPath(widthFt, heightFt, pxPerFt) {
    const fmt = (n) => Math.round(n * pxPerFt * 100) / 100;
    return (halfRoundOutline(widthFt, heightFt)
        .map((p, i) => `${i === 0 ? 'M' : 'L'} ${fmt(p.x)},${fmt(p.y)}`)
        .join(' ') + ' Z');
}
/**
 * Chairs spread evenly round the curve, none on the flat edge, each facing
 * the table. Centres relative to the box centre.
 */
export function calculateHalfRoundChairs(widthFt, heightFt, seatCount, chairSizeFt = 1.5) {
    const gap = chairSizeFt * CHAIR_OFFSET;
    const a = widthFt / 2;
    const b = heightFt;
    const positions = [];
    for (let i = 0; i < seatCount; i++) {
        const angle = (Math.PI * (i + 0.5)) / seatCount;
        // Stand off the edge along its normal, and face back along it, so a chair
        // on a flattened half-oval sits square to — and the same distance from —
        // the edge in front of it, not drifting off it as a radial offset would.
        const nx = b * Math.cos(angle);
        const ny = a * Math.sin(angle);
        const len = Math.hypot(nx, ny) || 1;
        positions.push({
            x: a * Math.cos(angle) + (gap * nx) / len,
            y: -heightFt / 2 + b * Math.sin(angle) + (gap * ny) / len,
            rotation: (Math.atan2(ny, nx) * 180) / Math.PI + 90,
        });
    }
    return positions;
}
//# sourceMappingURL=halfRound.js.map